import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { LabpartnerService } from 'src/app/services/labpartner.service';

export interface IBarcodeDialogData {
  experimentId: number;
  identifier: string;
  expiry: Date;
}

@Component({
  selector: 'app-barcode-dialog',
  templateUrl: './barcode-dialog.component.html',
  styleUrls: ['./barcode-dialog.component.scss'],
  standalone: false,
})
export class BarcodeDialogComponent implements OnInit, OnDestroy {
  barcodeImageLink?: string;
  barcodeRouterLink?: string;
  barcodeLinkFragment?: string;
  private readonly destroying$ = new Subject<void>();

  constructor(
    private apiService: LabpartnerService,
    @Inject(MAT_DIALOG_DATA) public data: IBarcodeDialogData,
    public dialogRef: MatDialogRef<BarcodeDialogComponent>,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit() {
    const barcodePath = `mobile-barcodes/${this.data.experimentId}`;
    this.barcodeRouterLink = `/${barcodePath}`;
    this.barcodeLinkFragment = this.data.identifier;
    const linkTarget = new URL(this.barcodeRouterLink, this.document.location.origin);
    linkTarget.hash = this.data.identifier;

    this.apiService
      .getMobileBarcodeQrImage(linkTarget.href)
      .pipe(takeUntil(this.destroying$))
      .subscribe(image => {
        this.barcodeImageLink = URL.createObjectURL(image);
      });
  }

  ngOnDestroy() {
    this.destroying$.next();
    this.destroying$.complete();

    if (this.barcodeImageLink) {
      URL.revokeObjectURL(this.barcodeImageLink);
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
